export const USER_LOGOUT = 'USER_LOGOUT';
export const TOGGLE_SIDE_BAR = 'TOGGLE_SIDE_BAR';
export const REMOVE_SELECTED_BOT = 'REMOVE_SELECTED_BOT';
export const UPDATE_SELECTED_BOT = 'UPDATE_SELECTED_BOT';
export const UPDATE_SELECTED_BOT_ID = 'UPDATE_SELECTED_BOT_ID';
export const TOGGLE_BOT_CUSTOM_STATE = 'TOGGLE_BOT_CUSTOM_STATE';
export const CURRENT_TAB_STATUS = 'CURRENT_TAB_STATUS';
export const UPDATE_BOT_DATA = 'UPDATE_BOT_DATA';
export const GET_BOT_DATA = 'GET_BOT_DATA';
export const UPSERT_BOT_DATA = 'UPSERT_BOT_DATA';
export const BUILD_BOT = 'BUILD_BOT';
export const UPDATE_BLOCKED_UI_STATE = 'UPDATE_BLOCKED_UI_STATE';
export const DOWNLOAD_BOT_CONFIG = 'DOWNLOAD_BOT_CONFIG';

export const GET_MFA_STATUS = 'GET_MFA_STATUS';
export const LOGIN_USER = 'LOGIN_USER';
export const MULI_FACTOR_SETUP = 'MULI_FACTOR_SETUP';
export const UPDATE_USER_DETAILS = 'UPDATE_USER_DETAILS';
export const UPDATE_BOT_LIST = 'UPDATE_BOT_LIST';
export const GET_BOT_LIST_DATA = 'GET_BOT_LIST_DATA';
export const GET_SELECTED_BOT_DATA = 'GET_SELECTED_BOT_DATA';
export const UPDATE_SELECTED_BOT_CONFIG = 'UPDATE_SELECTED_BOT_CONFIG';

export const GET_LOGS = 'GET_LOGS';
export const GET_LOGS_SUCCESS = 'GET_LOGS_SUCCESS';
export const GET_LOGS_ERROR = 'GET_LOGS_ERROR';

export const LOAD_CONFIG = 'LOAD_CONFIG';
export const LOAD_CONFIG_SUCCESS = 'LOAD_CONFIG_SUCCESS';
export const LOAD_CONFIG_ERROR = 'LOAD_CONFIG_ERROR';

export const HIGHLIGHT_SEARCHED_RESULT = 'HIGHLIGHT_SEARCHED_RESULT';

export const UPDATE_GENERIC_TAB_STATUS = 'UPDATE_GENERIC_TAB_STATUS';
export const GET_GENERIC_DATA = 'GET_GENERIC_DATA';
export const DOWNLOAD_GENERIC_DATA = 'DOWNLOAD_GENERIC_DATA';
export const SUCCESS_GENERIC_DATA = 'SUCCESS_GENERIC_DATA';
export const ERROR_GENERIC_DATA = 'ERROR_GENERIC_DATA';
export const UPDATE_GENERIC_DATA = 'UPDATE_GENERIC_DATA';
export const SAVE_GENRIC_DATA = 'SAVE_GENRIC_DATA';
export const SUCCESS_SAVE_GENRIC_DATA = 'SUCCESS_SAVE_GENRIC_DATA';
export const ERROR_SAVE_GENRIC_DATA = 'ERROR_SAVE_GENRIC_DATA';
export const RELOGIN_USER = 'RELOGIN_USER';
export const RESET_VERSION = 'RESET_VERSION';
export const UPDATE_CURRENT_FIRSTPARAM = 'UPDATE_CURRENT_FIRSTPARAM';
export const UPDATE_GENERIC_LANG = 'UPDATE_GENERIC_LANG';

export const UPDATE_CREATE_MENU_VISIBILITY = 'UPDATE_CREATE_MENU_VISIBILITY';
export const UPDATE_CREATE_MENU_DATA = 'UPDATE_CREATE_MENU_DATA';
export const UPDATE_CREATE_MENU_TYPE = 'UPDATE_CREATE_MENU_TYPE';

export const GET_BOT_INFO = 'GET_BOT_INFO';
export const GET_BOT_INFO_SUCCESS = 'GET_BOT_INFO_SUCCESS';
export const GET_BOT_INFO_ERROR = 'GET_BOT_INFO_ERROR';
export const UPDATE_SELECTED_SOURCE = 'UPDATE_SELECTED_SOURCE';
export const GET_SOURCE_LIST = 'GET_SOURCE_LIST';
export const GET_SOURCE_LIST_SUCCESS = 'GET_SOURCE_LIST_SUCCESS';
export const GET_SOURCE_LIST_ERROR = 'GET_SOURCE_LIST_ERROR';
